const checkRange = (value, maxValue, label) => {
  if (Number.isNaN(value) || value < 0 || value > maxValue) {
    throw new RangeError(`${value} for ${label} is not between 0 and ${maxValue}`);
  }
};

export default checkRange;
